/** `GetLocationAttention` — число «Нужно решить» на плашке локации. */
export const paymentQueryNames = ['GetPaymentJournal', 'GetPayment', 'GetLocationAttention'] as const;
